import { RealtyCalendarBannerContainer } from './RealtyCalendarBannerContainer';
import { attachReactComponent } from '../../common/attachReactComponent';

attachReactComponent(RealtyCalendarBannerContainer);
